/**
 * Heuristics for XHR/axios/fetch network failures (no parsable HTTP response).
 * Does not check navigator.onLine — use isTransientNetworkError for upload pause logic.
 */
export function isNetworkFailureError(error: unknown): boolean {
  const err = error as {
    isAxiosError?: boolean;
    code?: string;
    response?: { status?: number };
    status?: number;
    message?: string;
  };

  if (err?.response?.status != null && err.response.status > 0) {
    return false;
  }

  if (err?.isAxiosError && err.code === 'ERR_NETWORK' && !err.response) {
    return true;
  }

  if (err?.status === 0 || err?.response?.status === 0) {
    return true;
  }

  if (error instanceof TypeError) {
    return true;
  }

  if (typeof err?.message === 'string' && /network|failed to fetch|connection/i.test(err.message)) {
    return true;
  }

  return false;
}

/** True when offline or the error looks like a transient network failure (not a terminal HTTP error). */
export function isTransientNetworkError(error: unknown): boolean {
  if (typeof navigator !== 'undefined' && !navigator.onLine) {
    return true;
  }
  return isNetworkFailureError(error);
}
